export const useAuth = {
  user: undefined
}
